var _effectorFileName = "/builds/gmini/front-ui-kit/src/LongText/LongText.tsx";
import * as React from 'react';
import { styled } from '@mui/material';
import { Tooltip } from './../Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LongText = /*#__PURE__*/React.memo(({
  children,
  partSize,
  Component,
  onCutOff,
  withoutRightText,
  noMaxWidth,
  withoutTooltip,
  zIndexTooltip,
  tooltipEnterDelay,
  tooltipPlacement
}) => {
  const [bodyEl, setBodyEl] = React.useState(null);
  const [textEl, setTextEl] = React.useState(null);
  const [cutText, setCutText] = React.useState(false);
  React.useEffect(() => {
    const update = () => {
      if (textEl && bodyEl) {
        setCutText(textEl.offsetWidth > bodyEl.offsetWidth);

        if (onCutOff) {
          onCutOff(textEl.offsetWidth > bodyEl.offsetWidth);
        }
      }
    };

    update();
    const interval = setInterval(update, 100);
    return () => {
      onCutOff && onCutOff(false);
      clearInterval(interval);
    };
  }, [bodyEl, onCutOff, textEl]);
  const right = React.useMemo(() => children.slice(-partSize).trim(), [children, partSize]);
  return /*#__PURE__*/_jsxs(LongTextBody, {
    tag: Component,
    ref: setBodyEl,
    children: [/*#__PURE__*/_jsx(LongTextRaw, {
      tag: Component,
      display: cutText === false,
      ref: setTextEl,
      children: children
    }), cutText && /*#__PURE__*/_jsx(Tooltip, {
      noMaxWidth: noMaxWidth,
      title: withoutTooltip ? '' : children,
      placement: tooltipPlacement !== null && tooltipPlacement !== void 0 ? tooltipPlacement : 'bottom',
      zIndex: zIndexTooltip,
      enterDelay: tooltipEnterDelay !== null && tooltipEnterDelay !== void 0 ? tooltipEnterDelay : 100,
      enterNextDelay: tooltipEnterDelay !== null && tooltipEnterDelay !== void 0 ? tooltipEnterDelay : 0,
      children: /*#__PURE__*/_jsxs(LongTextOverload, {
        children: [/*#__PURE__*/_jsx(LongTextOverloadLeft, {
          children: children
        }), !withoutRightText && /*#__PURE__*/_jsx(LongTextOverloadRight, {
          children: right
        })]
      })
    })]
  });
});
LongText.displayName = 'LongText';
const LongTextBody = styled(
/*#__PURE__*/
// eslint-disable-next-line react/display-name
React.forwardRef(({
  tag: Tag = 'span',
  children,
  ...props
}, r) => /*#__PURE__*/_jsx(Tag, {
  ref: r,
  ...props,
  children: children
})))({
  overflow: 'hidden',
  position: 'relative',
  whiteSpace: 'nowrap',
  display: 'block',
  width: '100%'
});
const LongTextRaw = styled(
/*#__PURE__*/
// eslint-disable-next-line react/display-name
React.forwardRef(({
  display,
  tag: Tag = 'span',
  ...props
}, ref) => /*#__PURE__*/_jsx(Tag, {
  ref: ref,
  ...props
})))(({
  display
}) => ({
  visibility: display ? 'visible' : 'hidden',
  width: 'min-content',
  display: 'inline-block'
}));
const LongTextOverload = styled('span')({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex'
});
const LongTextOverloadLeft = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flexGrow: 1
});
const LongTextOverloadRight = styled('span')({});